import { tagmanagerObserveImpressions, tagmanagerPromotionsClickHandler, tagmanagerInitializePromotions, tagmanagerProductClickHandler } from "../tagmanager"

const initialState = window["state"]

window.onload = function () {
    const productOverviews = Array.from(document.querySelectorAll(".product-overview")) as HTMLElement[]
    const products = Array.from(document.querySelectorAll("[data-tagmanager-product]")) as HTMLElement[]
    const promotions = Array.from(document.querySelectorAll("[data-tagmanager-promo")) as HTMLElement[]

    if (productOverviews.length > 0) {
        productOverviews[0].id = "giftcards"
        productOverviews[1].id = "egifts"
        tagmanagerObserveImpressions(productOverviews, initialState.products)
    }

    tagmanagerProductClickHandler(products)
    tagmanagerPromotionsClickHandler(promotions, initialState.promotions)
    tagmanagerInitializePromotions(initialState.promotions)
}